module.exports = __webpack_public_path__ + "img/bank-card-2-fill.ca14d1c2.svg";